<template>
<div class="chapter">
<div class="inner_page">
<p class="block_19">
</p>
<p class="block_4"> </p>
<p class="block_4"> </p>
<p class="block_4"> </p>
<p class="block_4"> </p>
<p class="block_4"> </p>
<p class="block_4"> </p>
<p class="block_4"> </p>
<p class="block_2">Joseph Pearce is a literary critic, a historian, and a Shakespeare scholar. He is the author of thirty books, including <i class="calibre1">Tolkien: Man and Myth</i> and <i class="calibre1">Solzhenitsyn: A Soul in Exile</i>.</p>
<p class="block_3" id="calibre_pb_7"> </p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// index_split_007.vue?605eaa26